import { RefObject, useCallback, useMemo } from 'react';

type SectionOpenHandler = (open: boolean) => void;

type SectionConfig = {
  ref: RefObject<HTMLElement | null>;
  setOpen: SectionOpenHandler;
};

type SectionControls = Record<string, SectionConfig>;

export function useScrollToSection(sectionControls: SectionControls) {
  const stableControls = useMemo(() => sectionControls, [sectionControls]);

  return useCallback(
    (sectionId: string) => {
      const section = stableControls[sectionId];
      if (!section) return;

      section.setOpen(true);

      requestAnimationFrame(() => {
        section.ref.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });
    },
    [stableControls]
  );
}
